import { render, staticRenderFns } from "./UpsellProductModals.vue?vue&type=template&id=6e91248c&"
import script from "./UpsellProductModals.vue?vue&type=script&lang=ts&"
export * from "./UpsellProductModals.vue?vue&type=script&lang=ts&"
import style0 from "./UpsellProductModals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports